import { Component } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})
export class ContactUsComponent {}
